// extracted by mini-css-extract-plugin
module.exports = {"heading":"Heading_heading__njkQq","headingTitle":"Heading_headingTitle__D3bJk","actions":"Heading_actions__88oXm","moderatorReset":"Heading_moderatorReset__mSdiE"};